import { SwitchWithLabel } from "@/components/form/SwitchWithLabels";
import { HacsOmUploadData } from "@/features/hacs";
import { useAdaptationPermissions } from "@/utils/hooks/useAdaptationPermissions";
import { Collapse } from "antd";
import { useTranslation } from "react-i18next";
interface PortfolioExportAdvancedSettingsProps {
  data: HacsOmUploadData;
  setData: (data: HacsOmUploadData) => void;
  defaultOpen?: boolean;
}
export const PortfolioExportAdvancedSettings = ({
  data,
  setData,
  defaultOpen = false
}: PortfolioExportAdvancedSettingsProps) => {
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "settings"
  });
  const {
    t: terms
  } = useTranslation("terms");
  const {
    portfolioAutoAdaptabilityEnabled
  } = useAdaptationPermissions();
  const automatedResilience = {
    automatedResilience: terms("automatedResilience")
  };
  return <>
      <Collapse activeKey={defaultOpen ? "advanced-settings" : undefined} expandIconPlacement="start" className={"rounded-lg border border-subtle bg-surface *:!border-subtle [&_.ant-collapse-content]:border-t-0 [&_.ant-collapse-panel]:!border-subtle"} items={[{
      key: "advanced-settings",
      label: t("advancedAnalysisSettings"),
      classNames: {
        body: "!pt-1 !border-subtle border-t-0"
      },
      children: <div className="flex flex-col divide-y divide-gray-100 pt-2 *:py-4">
                {portfolioAutoAdaptabilityEnabled && <SwitchWithLabel id="automatedResilience" label={t("automatedResilience.title", automatedResilience)} description={t("automatedResilience.description", automatedResilience)} warning={t("automatedResilience.warningIfFalse", automatedResilience)} showWarning={!data.automatedResilience} checked={data.automatedResilience || false} onChange={(checked: boolean) => {
          setData({
            ...data,
            automatedResilience: checked
          });
        }} />}
                <SwitchWithLabel id="anomalyManagementRp" label={t("anomalyManagementRp.title")} description={t("anomalyManagementRp.description")} warning={t("anomalyManagementRp.warningIfFalse")} showWarning={!data.anomalyManagementRp} checked={data.anomalyManagementRp || false} onChange={(checked: boolean) => {
          setData({
            ...data,
            anomalyManagementRp: checked
          });
        }} />

                <SwitchWithLabel id="defences" label={t("defences.title")} description={t("defences.description")} warning={t("defences.warningIfFalse")} showWarning={!data.defences} checked={data.defences || false} onChange={(checked: boolean) => {
          setData({
            ...data,
            defences: checked
          });
        }} />
              </div>
    }]} data-sentry-element="Collapse" data-sentry-source-file="PortfolioExportAdvancedSettings.tsx" />
    </>;
};